import builder from '../builder';
import TimeClockCircle1Alternate from '../../streamline-icons/bold/time-clock-circle-1-alternate.svg';

export default builder(
  'IconTimeClockCircle1AlternateBold',
  TimeClockCircle1Alternate,
);
